import styles from './add-group-dialog.module.scss';
import { Col, Row } from 'reactstrap';
import { useContext, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, PrimaryButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface AddGroupDialogProps {
  open: boolean,
  onClose: () => void
}

export function AddGroupDialog(props: AddGroupDialogProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [groupName, setGroupName] = useState<string | undefined>('');

  const handleNewGroup = () => {
    makeRequest(`relationProductgroups/action/createnew/${groupName}`, 'POST')
      .then(result => {
        setSnackbarMessage({ content: t("addGroup.newGroupAdded"), type: "success" });
        props.onClose();
      }).catch(() => setSnackbarMessage({ content: t("addGroup.couldNotAddNewGroup"), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="md">
      <DialogTitle className='mb-4'>
        {t("standard.addProductGroup")}
      </DialogTitle>
      <DialogContent>
        <Row className="mb-3">
          <Col>
            <TextField
              fullWidth
              label={t("standard.groupName")}
              name='groupName'
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
          </Col>
        </Row>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={handleNewGroup}
          className='minButtonWidth'>
          OK
        </PrimaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default AddGroupDialog;